module.exports = __webpack_public_path__ + "images/external_images/img/32x32/img4.jpg";